import React from 'react';

// 1. Tag configuration exactly from your reference file
const TAG_CONFIG = {
  shuttle: {
    pos: ['Short wait', 'Clean shuttle', 'Friendly driver', 'On time', 'Helped with bags', 'Other'],
    neg: ['Long wait', 'Dirty shuttle', 'Rude driver', 'Late arrival', 'No luggage help', 'Other']
  },
  pickup: {
    pos: ['Clear instructions', 'Easy to find', 'Friendly staff', 'Short wait', 'Smooth process', 'Other'],
    neg: ['Confusing instructions', 'Hard to find', 'Unhelpful staff', 'Long wait', 'Poor signage', 'Other']
  },
  counter: {
    pos: ['Booking matched listing', 'Short wait', 'Helpful staff', 'Fast paperwork', 'No pressure', 'Other'],
    neg: ["Booking didn't match", 'Long wait', 'Unhelpful staff', 'Slow paperwork', 'Aggressive upsell', 'Other']
  },
  vehicle: {
    pos: ['Clean car', 'Great condition', 'Nice model', 'Good smell', 'Other'],
    neg: ['Dirty car', 'Poor condition', 'Older model', 'Bad smell', 'Other']
  },
  dropoff: {
    pos: ['Fast drop-off', 'No surprise charges', 'Friendly staff', 'Clear bill', 'Smooth return', 'Other'],
    neg: ['Slow drop-off', 'Surprise charges', 'Unfriendly staff', 'Unclear bill', 'Complicated return', 'Other']
  }
};

export default function FeedbackSection({ type, label, icon, data, onUpdate }) {
  // Determine if sentiment is positive (4-5) or negative (1-3)
  const isPositive = data.stars >= 4;
  const sentimentKey = isPositive ? 'pos' : 'neg';

  // Get the correct question and tag list
  const sectionConfig = TAG_CONFIG[type] || TAG_CONFIG['pickup']; // fallback
  const currentTags = sectionConfig[sentimentKey];
  const question = isPositive ? "What did you like?" : "What went wrong?";

  const toggleTag = (tag) => {
    const newTags = data.tags.includes(tag)
      ? data.tags.filter(t => t !== tag)
      : [...data.tags, tag];
    onUpdate({ tags: newTags });
  };

  return (
    <div className="mb-4 overflow-hidden rounded-lg border border-surface-border bg-surface font-body text-text">
      <div className="flex items-center gap-2 bg-dark px-4 py-2">
        <span>{icon}</span>
        <span className="font-heading text-[10px] font-bold uppercase tracking-[1.5px] text-primary">
          {label} Experience
        </span>
      </div>

      <div className="p-5 text-center">
        <p className="mb-4 font-heading text-sm font-bold text-text">How was the {type}?</p>

        {/* Stars */}
        <div className="flex justify-center gap-3 mb-5">
          {[1, 2, 3, 4, 5].map(n => (
            <button
              key={n}
              onClick={() => onUpdate({ stars: n, tags: [] })}
              className={`text-4xl transition-transform active:scale-125 focus:outline-none ${
                data.stars >= n 
                  ? 'text-primary' 
                  : 'text-transparent [text-shadow:_-1px_-1px_0_#e2e4e6,_1px_-1px_0_#e2e4e6,_-1px_1px_0_#e2e4e6,_1px_1px_0_#e2e4e6]'
              }`}
            >
              ★
            </button>
          ))}
        </div>

        {/* 2. TAG PANEL - Only shows if stars are selected */}
        {data.stars > 0 && (
          <div className="mb-6 animate-fadeIn">
            <p className="text-[11px] font-bold text-text mb-3 uppercase tracking-wider">{question}</p>
            <div className="flex flex-wrap justify-center gap-2">
              {currentTags.map(tag => (
                <button
                  key={tag}
                  onClick={() => toggleTag(tag)}
                  className={`px-3 py-1.5 rounded-full text-[11px] font-semibold border transition-all ${
                    data.tags.includes(tag)
                      ? 'bg-dark text-white border-dark'
                      : 'bg-surface text-text-muted border-surface-border hover:border-dark hover:text-text'
                  }`}
                >
                  {tag} {data.tags.includes(tag) ? '✕' : '+'}
                </button>
              ))}
            </div>
          </div>
        )}

        <label className="block text-left text-[11px] font-semibold text-text-muted mb-2">
          💬 Comment
        </label>

        <textarea 
          value={data.comment || ""}
          onChange={(e) => onUpdate({ comment: e.target.value })}
          className="w-full rounded-md border border-surface-border bg-surface-raised p-3 text-xs outline-none focus:border-dark text-text h-20 resize-none transition-all placeholder:text-text-muted"
          placeholder="Share your thoughts..."
        />
      </div>
    </div>
  );
}